
const messages = {
  en: {
    deposito: {
      title: 'Deposito management',
      menuTitle: 'Warehouses',
      subtitle: 'View, search, create, edit and delete Deposito',
      creating: 'Creating Deposito',
      editing: 'Editing Deposito',
      deleting: 'Deleting Deposito',
      showing: 'Showing Deposito',
      labels: {
        nombre: 'name',
        direccion: 'address',
        descripcion: 'description',
        telefono: 'phone',
        email: 'email',
        responsable: 'responsible',
        activo: 'active'
      },
    },
  },
  es: {
    deposito: {
      title: 'Administracion de Depósitos',
      menuTitle: 'Depósitos',
      subtitle: 'Ver, buscar, crear, editar, y borrar Depósitos',
      creating: 'Creando Depósito',
      editing: 'Modificando Depósito',
      deleting: 'Eliminando Depósito',
      showing: 'Detalles de Depósito',
      labels: {
        nombre: 'nombre',
        direccion: 'dirección',
        descripcion: 'descripción',
        telefono: 'tel�fono',
        email: 'email',
        responsable: 'responsable',
        activo: 'activo'
      },
    },
  },
  pt: {
    deposito: {
      title: 'Administra��o de Depositos',
      menuTitle: 'Depósitos',
      subtitle: 'Ver, buscar, criar, editar e usar Depositos',
      creating: 'Criando Deposito',
      editing: 'Edi��o Deposito',
      deleting: 'Apagando Deposito',
      showing: 'Detalhes do Deposito',
      labels: {
        nombre: 'nome',
        direccion: 'endere�o',
        descripcion: 'descri��o',
        telefono: 'telefone',
        email: 'email',
        responsable: 'respons�vel',
        activo: 'ativo'
      },
    },
  }
}

export default messages

